import { createCachedSelector, defaultKeySelector, path } from '@cbridge-utils/redux';
import { symbolPoolStoreSelector } from '../symbolPool.selector';

export const selectedNodeIdSelector = createCachedSelector(
  [
    path(symbolPoolStoreSelector).selected(),
  ],
  (selected) => {
    return selected;
  },
)({
  keySelector: defaultKeySelector,
});
